import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography, TextField, Button, MenuItem, Snackbar, Alert } from "@mui/material"
import { getCurrentDateString } from "../../../Utils/ValidationUtils";


const Request = ({ eveId, sessionId, requestID, selectedRequestbyID, onClose }) => {
    const port = process.env.REACT_APP_API_KEY;
    const accessToken = localStorage.getItem('token');

    const [value, setValue] = useState('1');
    const [remark, setRemark] = useState('');
    const [profData, setProfData] = useState([]);
    const [sesData, setSesData] = useState([]);

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        const getProfData = async () => {
            try {
                let url;
                if (eveId && sessionId) {
                    url = `${port}/web/professional_reuest_approval_rc/${eveId}/${sessionId}/`;
                } else {
                    url = `${port}/web/professional_reuest_approval_rc/${eveId}/`;
                }

                const res = await fetch(url, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                });
                const data = await res.json();
                console.log("Professional Data.......", data);
                if (data.message === "Data not found.") {
                    setProfData([]);
                    setSesData([])
                } else {
                    setProfData(data.eve_data[0]);
                    setSesData(data.ses)
                }
            } catch (error) {
                console.error("Error fetching Professional Data:", error);
            }
        };
        getProfData();
    }, [eveId, sessionId]);

    async function handleApproveSubmit(event) {
        event.preventDefault();
        const requestData = {
            eve_id: eveId,
            remark: remark,
            session_id: sessionId,
        };
        console.log("POST API Hitting......", requestData)
        try {
            const response = await fetch(`${port}/web/professional_reuest_approval/${requestID}/${selectedRequestbyID}/`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify(requestData),
            });
            if (!response.ok) {
                console.error(`HTTP error! Status: ${response.status}`);
                return;
            }
            const result = await response.json();
            console.log("Approve data", result);
            setOpenSnackbar(true);
            setSnackbarMessage('Request approved successfully!');
            // onClose();
            window.location.reload();
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }

    return (
        <Box sx={{ marginTop: "20px" }}>
            {requestID === '1' && (
                <Box sx={{ background: "#FFC9C9", mt: 5, pt: 1.5, px: 5, pb: 1.5, borderRadius: "8px" }}>
                    <Typography variant='subtitle2' style={{ fontSize: "20px", fontWeight: 600, color: "#B00000" }}>CANCEL REQUEST</Typography>
                </Box>
            )}
            {requestID === '2' && (
                <Box sx={{ background: "#E4ECFF", mt: 5, pt: 1.5, px: 5, pb: 1.5, borderRadius: "8px" }}>
                    <Typography variant='subtitle2' style={{ fontSize: "20px", fontWeight: 600, color: "#003FE0" }}>RESCHEDULE REQUEST</Typography>
                </Box>
            )}

            <Typography variant='body2' style={{ fontWeight: 600, marginTop: "15px" }}>Service Summary</Typography>
            <Box sx={{ background: "#F8F9FF", mt: 1, pt: 1, px: 2, pb: 1, borderRadius: "8px" }}>
                <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                    <Typography inline variant="body2" color="text.secondary" >Patient Name</Typography>
                    <Typography inline variant="body2">{profData?.agg_sp_pt_id?.name || '-'}</Typography>
                </Grid>

                <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                    <Typography inline variant="body2" color="text.secondary" >Event ID</Typography>
                    <Typography inline variant="body2">{profData ? profData.event_code : '-'}</Typography>
                </Grid>

                <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                    <Typography inline variant="body2" color="text.secondary" >Service</Typography>
                    <Typography inline variant="body2">{profData?.epoc_data?.[0]?.srv_id?.service_title || '-'}</Typography>
                </Grid>

                <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                    <Typography inline variant="body2" color="text.secondary" >Existing Service Date</Typography>
                    <Typography inline variant="body2">{profData?.epoc_data?.[0]?.start_date || '-'}</Typography>
                </Grid>

                <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                    <Typography inline variant="body2" color="text.secondary" >Requested Date</Typography>
                    <Typography inline variant="body2">{sesData ? sesData.added_date : '-'}</Typography>
                </Grid>
            </Box>
            <Grid sx={{ mt: 3 }}>
                <TextField
                    required
                    id="remark"
                    name="remark"
                    label="Remark"
                    placeholder='write remark here'
                    size="small"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    fullWidth
                    multiline
                    rows={2}
                    sx={{
                        '& input': {
                            fontSize: '14px',
                        },
                    }}
                />
            </Grid>

            {requestID === '1' && (
                <Button variant="contained" sx={{ mt: 4, mb: 3, ml: 6, width: "25ch", textTransform: "capitalize", borderRadius: "8px", background: "#69A5EB" }} onClick={handleApproveSubmit}>Cancel Request</Button>
            )}
            {requestID === '2' && (
                <Button variant="contained" sx={{ mt: 4, mb: 3, ml: 6, width: "25ch", textTransform: "capitalize", borderRadius: "8px", background: "#69A5EB" }} onClick={handleApproveSubmit}>Reschedule Request</Button>
            )}

        </Box>
    )
}

export default Request
